<template>
    <div>
        <v-dialog v-model="isActive" width="680" transition="dialog-bottom-transition" scrollable
            :fullscreen="$vuetify.breakpoint.mobile">
            <v-card class="rounded-0 ">
                <v-card flat class="rounded-0 ">
                    <v-app-bar color="white" height="50" elevation="0">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon @click.outside="cerrarDialogo"
                                    @keydown.esc="cerrarDialogo">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <span>Cerrar</span>
                        </v-tooltip>
                        <v-toolbar-title>
                            <div class="text-h6 font-weight-bold primary--text">
                                {{ titulo }}
                            </div>
                        </v-toolbar-title>
                    </v-app-bar>
                </v-card>
                <v-card-text class="d-flex flex-column align-center">
                    <v-card flat class="pt-4 rounded-0" width="430px"
                        :class="($vuetify.breakpoint.mobile) ? 'pb-12' : 'pb-3'">
                        <div ref="contenido" style="border: 1px solid #e0e0e0;">
                            <v-card color="primary" class="pa-4 align-center justify-center d-flex rounded-0" flat>
                                <v-img max-width="220px" max-height="70" height="70" src="@/assets/Logo-white.png" />
                            </v-card>
                            <v-card flat>
                                <v-card-title class="font-weight-bold primary--text text-h6">
                                    Comprobante de pago
                                </v-card-title>
                                <v-card-subtitle class="font-weight-bold black--text text-h6 ">
                                    {{ selectedItem.mmp_fecpago_real }}
                                </v-card-subtitle>
                                <v-row>
                                    <v-col cols="7" md="7">
                                        <v-card-title class="font-weight-bold body-1">
                                            Importe:
                                        </v-card-title>
                                        <v-card-subtitle class="font-weight-bold black--text text-h5">
                                            {{ formatMoney(selectedItem.mmp_apagar) }}
                                        </v-card-subtitle>
                                    </v-col>
                                    <v-col cols="5" md="5" class="d-flex flex-column justify-end ">
                                        <v-card-title class="font-weight-regular text-h6 black--text">
                                            Conceptos: {{ selectedItem.cantidad_conceptos }}
                                        </v-card-title>
                                        <!--                                     <v-card-subtitle class="font-weight-bold black--text text-body-1">
                                        {{ selectedItem.cantidad_conceptos }}
                                    </v-card-subtitle> -->
                                    </v-col>
                                </v-row>
                                <v-divider class="mx-5"></v-divider>
                                <v-card-title class="font-weight-bold text-body-1 py-1">
                                    {{ pronombre }}:
                                </v-card-title>
                                <div class="d-flex flex-column font-weight-regular mx-5 my-0 py-0">
                                    {{ user.nombres }} {{ user.apellido }}
                                </div>
                                <v-card-title class="font-weight-bold text-body-1 py-1">
                                    MP:
                                </v-card-title>
                                <div class="d-flex flex-column font-weight-regular mx-5 my-0 py-0">
                                    {{ selectedItem.mmp_nroafi }}
                                </div>
                                <v-divider class="mx-5"></v-divider>
                                <v-card-title class="font-weight-bold text-body-1">
                                    Detalle:
                                </v-card-title>
                                <v-card-text flat class="pl-4 ma-1 ">
                                    <v-row v-for="(item, index) in selectedItem.detalle" :key="index"
                                        class=" font-weight-regular py-0 text-body-1">
                                        <div class="text-start ml-3">
                                            {{ item.descripcion }}
                                        </div>
                                        <v-spacer></v-spacer>
                                        <div
                                            class="d-flex flex-column font-weight-bold justify-center align-center mr-8">
                                            {{ formatMoney(item.monto) }}
                                        </div>
                                    </v-row>
                                </v-card-text>
                                <v-divider class="mx-4"></v-divider>
                                <!--                             <v-card-title class="font-weight-regular text-h6 black--text">
                                Pago procesado por:
                            </v-card-title>
                            <v-card-subtitle class="font-weight-bold black--text text-body-1">
                                MercadoPago
                            </v-card-subtitle> -->
                                <v-card-title class="font-weight-regular text-h6 black--text">
                                    Medio de pago:
                                </v-card-title>
                                <v-card-subtitle class="font-weight-bold black--text text-body-1">
                                    {{ selectedItem.mmp_tipo_pago_mercado_pago }}
                                </v-card-subtitle>
                                <v-divider class="mx-4"></v-divider>
                                <v-card-title class="font-weight-regular text-h6 black--text">
                                    Identificación de pago:
                                </v-card-title>
                                <v-card-subtitle class="font-weight-bold primary--text text-body-1">
                                    {{ selectedItem.mmp_referencia_externa }}
                                </v-card-subtitle>
                                <!--                             <v-card-title class="font-weight-regular text-body-1 black--text"
                            style="word-break: keep-all;">
                            Podés encontrar más información sobre tus pagos entrando con tu usuario al Portal Web de
                            la
                            Caja
                        </v-card-title> -->
                            </v-card>
                        </div>
                    </v-card>
                    <v-card-text class="d-flex justify-center align-center pb-1"
                        :class="($vuetify.breakpoint.mobile) ? 'form-footer ' : ''">
                        <v-btn @click="exportarPDF" class="pa-5 elevation-0" :loading="loading" color="primary"> <v-icon
                                class="mr-2">far
                                fa-file-pdf</v-icon>Descargar
                            PDF</v-btn>
                    </v-card-text>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
    name: 'DialogoComprobantePago',

    components: {
    },
    data() {
        return {
            isActive: false,
            url: '',
            show: false,
            loading: false

        }
    },
    props: ['titulo', 'selectedItem'],

    computed: {
        ...mapGetters('auth', ['user']),
        pronombre() {
            switch (this.user.sexo) {
                case "M":
                    return "Afiliado"
                case "F":
                    return "Afiliada"
                default:
                    return "Afiliadx"
            }
        },
    },
    methods: {
        //...mapActions('auth', ['generarCredencialAfiliado', 'generarCredencialJubilado', 'generarConstanciaConvenios']),

        cerrarDialogo() {
            this.isActive = false
        },
        abrirDialogo() {
            this.isActive = true
        },
        formatMoney(value) {
            return value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
        },
        exportarPDF() {
            this.$nextTick(() => {
                this.loading = true;
                const elemento = this.$refs.contenido;

                if (!elemento) {
                    console.error("El elemento no está disponible en el DOM.");
                    return;
                }

                html2canvas(elemento, { scale: 1.2 }).then(canvas => {
                    const imgData = canvas.toDataURL("image/png");
                    const pdf = new jsPDF("p", "mm", "a4");

                    const pageWidth = pdf.internal.pageSize.getWidth(); // Ancho A4 (210mm)
                    const pageHeight = pdf.internal.pageSize.getHeight(); // Alto A4 (297mm)

                    const imgWidth = pageWidth - 90; // Margen de 20mm en cada lado
                    const imgHeight = (canvas.height * imgWidth) / canvas.width;

                    // Si la imagen es más alta que la página A4, se ajusta
                    let finalImgHeight = imgHeight;
                    let finalImgWidth = imgWidth;

                    if (imgHeight > pageHeight - 40) {
                        finalImgHeight = pageHeight - 40; // Ajusta altura dentro del A4
                        finalImgWidth = (canvas.width * finalImgHeight) / canvas.height;
                    }

                    const x = (pageWidth - finalImgWidth) / 2; // Centrar horizontalmente
                    const y = 10; // posicion a 10cm del borde superior

                    pdf.addImage(imgData, "PNG", x, y, finalImgWidth, finalImgHeight);
                    const referencia = this.selectedItem.mmp_referencia_externa.slice(-7);
                    pdf.save(`caja_de_psicologos_${referencia}.pdf`);
                }).catch(error => console.error("Error al generar el PDF:", error))
                    .finally(() => {
                        this.loading = false;
                    });
            });
        }

    }

}

</script>

<style>
.form-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: white;
    padding: 10px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
}
</style>